import { InlineWidget } from 'react-calendly'
import BasicSlide from './BasicSlide'

export const CalendarSlide = ({
  calendalyUrl,
  thumb,
  cardTitle,
  cardSubtitle,
  ...props
}) => {
  return (
    <BasicSlide
      rightContent={
        <div className='cal-right-container'>
          <div className='acc-header border p-2 our-rounded mb-3'>
            <div className='accordion-header-logo-and-title'>
              <img
                src={thumb}
                className={'accordion-logo me-3 rounded-circle'}
                alt='nonsense'
              />
              <div>
                <div className='acc-title'>{cardTitle}</div>
                <div
                  className='acc-subtitle'
                  style={cardSubtitle === null ? { display: 'none' } : {}}
                >
                  {cardSubtitle}
                </div>
              </div>
            </div>
          </div>
          <div className='p-1 border rounded cal-container'>
            <InlineWidget
              // className={'border rounded p-3'}
              url={`${calendalyUrl}?hide_gdpr_banner=1`}
              styles={{
                height: '500px', // 630px min
                width: '330px' // 330px min
                // border: '1px solid #dee2e6',
                // borderRadius: '1.25rem'
              }}
              pageSettings={{
                backgroundColor: 'ffffff',
                hideEventTypeDetails: true,
                hideLandingPageDetails: true,
                primaryColor: '000000',
                textColor: '4d5055'
              }}
            />
          </div>
        </div>
      }
      {...props}
    />
  )
}

export default CalendarSlide
